import { setSession } from '../utils/authStorage';
import { api } from './client';

function formatApiError(data) {
  if (!data || typeof data !== 'object') return 'Đã xảy ra lỗi. Vui lòng thử lại.';
  if (typeof data.detail === 'string') return data.detail;
  if (Array.isArray(data.detail)) {
    return data.detail.map((d) => (typeof d === 'string' ? d : d?.string || JSON.stringify(d))).join(' ');
  }
  if (Array.isArray(data.non_field_errors)) {
    return data.non_field_errors.join(' ');
  }
  const parts = [];
  Object.entries(data).forEach(([key, val]) => {
    if (key === 'detail') return;
    if (Array.isArray(val)) parts.push(`${key}: ${val.join(' ')}`);
    else if (typeof val === 'string') parts.push(`${key}: ${val}`);
    else if (val && typeof val === 'object') parts.push(`${key}: ${JSON.stringify(val)}`);
  });
  return parts.length ? parts.join(' ') : 'Đã xảy ra lỗi. Vui lòng thử lại.';
}

export async function loginWithEmail(email, password) {
  // Backward compatible: treat "email" as username identifier.
  return loginWithUsername(email, password);
}

export async function loginWithUsername(username, password) {
  const { data } = await api.post('/api/auth/login/', {
    username: username.trim(),
    password,
  });
  setSession({
    access: data.access,
    refresh: data.refresh,
  });
  const meRes = await api.get('/api/auth/me/');
  setSession({ user: meRes.data });
  return { ...data, user: meRes.data };
}

export async function registerAccount(payload) {
  const { data } = await api.post('/api/auth/register/', payload);
  setSession({
    access: data.access,
    refresh: data.refresh,
  });
  const meRes = await api.get('/api/auth/me/');
  setSession({ user: meRes.data });
  return data;
}

export { formatApiError };

